module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-smile-upside-down-78aa799d.svg";